export default {"src":"/_next/static/media/AppTracking.3fae1c64.svg","height":39,"width":41,"blurWidth":0,"blurHeight":0};